export const MAP_PROXY_URL = 'gisbis/MapProxy/layer'
export const MAP_WMS_URL = 'gisbis/map/api/wms'
